import { useQuery } from '@tanstack/react-query';
import { type IMessage } from 'react-native-gifted-chat';

type ChatQueryData = {
  pages: { messages: IMessage[] }[];
};

const EMPTY_MESSAGES: IMessage[] = [];

/**
 * Hook to access conversation messages from React Query cache.
 * Subscribes to cache updates so the component re-renders when messages arrive.
 *
 * @param conversationId - Twilio conversation SID
 * @returns Array of messages from cache, or empty array if none exist
 */
export function useConversation(conversationId: string): IMessage[] {
  const { data } = useQuery<ChatQueryData, Error, IMessage[]>({
    queryKey: ['chat', conversationId],
    enabled: false,
    select: (queryData) =>
      queryData?.pages ? queryData.pages.flatMap((page) => page.messages) : EMPTY_MESSAGES,
  });

  return data ?? EMPTY_MESSAGES;
}
